module.exports = __webpack_public_path__ + "img/hospitalisation.baf2c178.jpg";